import _ from "lodash";
import { shallowEqual, useSelector } from "react-redux";
import { ENTITY_TYPE } from "../../constants";
import {useCoreEntityContext} from "../useCoreEntitySlice";
import {selectContextEntity} from "../../state/slices/CoreEntity";

const useContextDevices = (selectedOnly, deviceType) => {
    const useCoreEntitySlice = useCoreEntityContext();

    return useSelector((state) => getDevicesByFacility(
        useCoreEntitySlice ? selectContextEntity(state) : state.entities.Context, state.entityScope,
        selectedOnly,
        deviceType
    ), shallowEqual);
}

function getDevicesByFacility(context, entityScope, selectedOnly, deviceType) {
    var results = [];

    let deviceList = getDevicesOrderAlphabetically(context.children);

    if (deviceType === "Door" && deviceList?.length > 0) {
         deviceList = deviceList.filter(x => x.deviceMode === deviceType);
    } else if((deviceType === "Gate") && deviceList?.length > 0){
        deviceList = deviceList.filter(x => x.deviceMode === "Entry" || x.deviceMode === "Exit");
    }
    if (_.isNil(entityScope.facilityGroupId)) {
    results.push({ name: context.name, id: context.entityid, devices: deviceList });
    } else {
    getDevicesForFacilityGroup(entityScope, results, selectedOnly,deviceType);
    }
    return results;
}

function getDevicesForCurrentContext(context) {
    if (_.isNil(context.children) || context.children.length <= 0) {
        return [];
    }
    return getDevicesOrderAlphabetically(context.children);
}

function getDevicesForFacilityGroup(entityScope, results, selectedOnly, deviceType) {
    if (_.isNil(entityScope.available)) { return; }
    for (let facility of entityScope.available) {
        if (_.isNil(facility.children) || facility.children.length <= 0) {
        continue;
        }

        let deviceList = facility.children;
        if(deviceType === "Door"){
            deviceList = deviceList.filter(x => x.deviceMode === "Door");
        } else if(deviceType === "Gate"){
            deviceList = deviceList.filter(x => x.deviceMode === "Entry" || x.deviceMode === "Exit");
        }
        if (selectedOnly && entityScope.selected.filter(x => x.id == facility.id).length == 0) { continue; }

        results.push({ name: facility.name, id: facility.id, devices: getDevicesOrderAlphabetically(facility.children) })
    }
}

function getDevicesOrderAlphabetically(entityList) {
    let devices = [];
    (function TryAddDevices(entityList) {
        if (_.isNil(entityList) || entityList.length <= 0) { return; }
        for (let entity of entityList) {
            const deviceMode = entity.settings?.find(x => x.name === "devicemode")?.value ?? entity.deviceMode;
            // OR on typeid/entityType to support both entity context and available context naming schema
            if (entity.typeid === ENTITY_TYPE.Device || entity.entityType === ENTITY_TYPE.Device) {
                // OR on entityid/id to support both entity context and available context naming schema
                devices.push({ name: entity.name, entityid: entity.entityid || entity.id , deviceMode: deviceMode });
            } else if (entity.children) {
                TryAddDevices(entity.children);
            }
        }
    })(entityList);
    return _.orderBy(devices, ["name"], ["asc"]);
}


export default useContextDevices;